import React from "react";
import "../App.css";
import clsx from "clsx";
import Helper from "./helper";
import Global from "./global";
import ErrorComponent from "../components/UI/error";

// SVG Icons
import { Caret, Close, Help, UserHeader } from "../common/icons";

import Background from "../assets/images/accor-plus-logo.png";

const Header = ({
  goPreviousStep,
  step,
  headerText,
  handleShowModal,
  isUserLogged,
  locationDatas,
}) => {
  const routeChange = () => {
    const { referrer } = document;
    const currentUrl = Helper.getUrl();
    const path =
      referrer === window.location.href ? currentUrl.urlRoot : referrer;
    window.location.replace(path);
  };

  let isProd = window.location.href.indexOf("accorplus") != -1;

  return (
    <div className="header tablet:py-8 xs:pt-5 xs:pb-8">
      <div className="holder-main-nav flex">
        {/* <div className='holder-logo'>
              <a href={isProd ? 'https://www.accorplus.com' : '#'}>
                  <img
                      src={Background} 
                      className="d-inline-block align-top header-logo"
                      alt="Accorplus Logo"
                  />
              </a>
          </div> */}
        {/* <div className='holder-icons items-center ml-auto flex'>
              <div className={clsx('icon-user mr-5', {
                'logged-in': isUserLogged, //static
              }
              )}>
                  <a href={Global.LOGIN_URL}>
                    <UserHeader />
                  </a>
              </div>
              <div className='icon-help'>
                  <button 
                    onClick={handleShowModal}
                    type='button'
                  ><Help /></button>
              </div>
          </div> */}
      </div>

      {/* {locationDatas && locationDatas.globalMessage ?
        <div class="mt-4">
          <ErrorComponent errorMessage={locationDatas.globalMessage}></ErrorComponent>
        </div>
      : ""} */}

      {/* <div className='navigation flex items-center mt-14'>
          <div className='back-button mr-auto'>
              <button 
                  type='button'
                  className={clsx('button-icon',
                    {
                      'disabled': step === 1 || step >= 10 ? true : false, 
                    }
                  )}
                  disabled={step === 1 ? true : false}
                  onClick={goPreviousStep}
              ><Caret /></button>
          </div>
          <div className='nav-heading justify-center text-center mx-auto'>
              <p className='navigation-text xs:text-sm font-montserrat font-medium uppercase'>{ headerText }</p>
          </div>
          <div className='close-button ml-auto'>
              <button type='button' onClick={routeChange}><Close /></button>
          </div>
      </div> */}
    </div>
  );
};

export default Header;
